import { app, Component, ojs } from "modular-openscriptjs";
import { either, fireEvent, getComponent } from "../../helpers";
import { dom, tool } from "../../fotastart";
import { $e } from "../../ojs.events";
import QrScanner from "qr-scanner";
import { gc } from "../../declarations";

const h = app('h');
const broker = app('broker');

export default class QRScanForm extends Component {
	modal;

	renderForm(...args) {
		return h.div(
			h.div(
				{
					class: "bg-light rounded",
				},
				either(
					gc.qrScanner,
					gc.qrScanner?.$video,
					h.video({
						muted: true,
						class: "d-block h-100 w-100",
						id: "qr-scan-form-video",
					})
				)
			),
			...args
		);
	}

	$$qr = {
		needs: {
			scanForm: (ed, event) => this.showForm(ed, event),
		},
		has: {
			scanResult: (ed, event) => {
				this.modal.close();
			},
		},
	};

	$_mounted(componentId) {
		if (gc.qrScanner) return;

		let c = getComponent(componentId);
		if(!c) return;

		setTimeout(() => {
			c.innitScanner();
		}, 1000);
	}

	innitScanner() {
		gc.qrScanner = new QrScanner(
			dom.id("qr-scan-form-video"),
			(result) =>
				broker.send($e.qr.needs.resultHandling, payload({ result })),
			{
				highlightScanRegion: true,
				highlightCodeOutline: true,
				alsoTryWithoutScanRegion: true,
			}
		);
		gc.qrScanner.setInversionMode("both");
	}

	async showForm(ed, event) {
		console.log("Here");

		if (this.modal) {
			this.modal.object.show();
		} else {
			let options = new tool.ModalOptions();
			options.buttons.right.visible = false;
			options.buttons.left.visible = false;
			options.staticBackdrop();
			options.removeOnClose = false;

			if (this.modal) {
				this.modal.close();
			}

			const { modal } = tool.modal("Scan QR", this.renderForm(), options);
			this.modal = modal;

			dom.id(`customModal-${modal.id}`)?.addEventListener(
				"hide.bs.modal",
				() => {
					gc.qrScanner.stop();
				}
			);
		}

		setTimeout(() => {
			fireEvent($e.qr.has.visibleForm);
		}, 1000);
	}
}

ojs(QRScanForm);
